export const jaContent = {
  introduction: {
    content: [
      "1996年の誕生以来、ポケットモンスターシリーズは世界中の人々の心を魅了し、世界で最も愛されているエンターテインメントブランドの一つとなりました。私たちのランダムポケモンジェネレーターは、新しいポケモンを発見したい、バランスの取れたチームを作りたい、あるいはポケモンの旅で驚きを楽しみたいと考えるすべての年齢のトレーナーのために設計されています。",
      "次の大会用チームのインスピレーションを求めているベテラントレーナーでも、ポケモン図鑑を充実させたいカジュアルファンでも、このポケモンランダマイザーツールを使えば、広大なポケモンの世界を楽しく対話的に探索することができます。"
    ]
  },
  howToUse: {
    content: [
      "ランダムポケモンピッカーの使い方はシンプルで直感的です。以下の手順に従って、理想的なポケモンチームを生成してみましょう：",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "ポケモンの数を選択：生成したいポケモンの数（1～8匹）を決めます。" },
          { type: "text", content: "タイプを選択：ほのお、みず、でんきなど特定のタイプでフィルタリングするか、\"すべて\"を選択してすべてのタイプを含めることができます。" },
          { type: "text", content: "世代を選択：第一世代から第八世代まで、または\"すべて\"を選択してすべての世代のポケモンを含めることができます。" },
          { type: "text", content: "レア度を設定：生成されるポケモンのレア度を決定します。" },
          { type: "text", content: "\"生成\"をクリック：設定が完了したら、ボタンをクリックして条件に合うポケモンを生成します。" },
          { type: "text", content: "結果を確認：各ポケモンの種族値、特性、タイプなど、詳細な情報を確認できます！" }
        ]
      },
      "パラメータはいつでも調整でき、何度でも試して異なるポケモンの組み合わせを発見することができます。"
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "完全無料：ランダムポケモンジェネレーターは100%無料で、隠れた料金やサブスクリプション料は一切ありません。" },
          { type: "text", content: "カスタマイズ可能：タイプ、世代、レア度でフィルタリングして、ランダム選択をカスタマイズできます。" },
          { type: "text", content: "学習ツール：様々なポケモンの種族値、特性、タイプについて学ぶことができます。" },
          { type: "text", content: "チーム構築：カジュアルバトルや公式大会向けのバランスの取れたチームを素早く生成できます。" },
          { type: "text", content: "チャレンジ作成：ランダムに生成されたポケモンのみを使用する独自のチャレンジを作成できます。" },
          { type: "text", content: "アカウント不要：登録や個人情報の入力なしで、すぐに使い始めることができます。" }
        ]
      }
    ]
  },
  history: {
    content: [
      "ポケットモンスターシリーズは、1996年に田尻智氏がニンテンドーゲームボーイ向けに最初のポケモンゲームを作成したことから始まりました。田尻氏の子供時代の昆虫採集の趣味にインスピレーションを受け、\"ポケットモンスター\"（略してポケモン）と呼ばれる生き物を捕まえ、育て、バトルするという概念が生まれました。",
      "ポケモンの歴史における重要な出来事：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996年：日本で『ポケットモンスター 赤・緑』を発売" },
          { type: "text", content: "1998年：海外で『ポケットモンスター 赤・青』を発売" },
          { type: "text", content: "1999年：ポケモンカードゲームを世界展開" },
          { type: "text", content: "2000年：『ポケットモンスター 金・銀』を発売、100匹の新ポケモンを追加" },
          { type: "text", content: "2016年：『Pokémon GO』を発売、モバイルプラットフォームへ展開" },
          { type: "text", content: "2019年：Nintendo Switchで『ポケットモンスター ソード・シールド』を発売" }
        ]
      },
      "現在では、8世代900種類以上のポケモンを擁し、ビデオゲーム、カードゲーム、アニメシリーズ、映画、グッズ、モバイルアプリケーションなど、史上最も収益性の高いメディアフランチャイズの一つへと成長しています。"
    ]
  },
  popularPokemon: {
    content: [
      "ポケモンの歴史の中で、いくつかのポケモンはシリーズを代表するシンボル的な存在となっています：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "ピカチュウ：シリーズのマスコットである電気タイプのポケモン。稲妻の形の尻尾とピンク色の頬が特徴です。" },
          { type: "text", content: "リザードン：ファンに人気の高いほのお・ひこうタイプのポケモン。ドラゴンのような外見と強力な能力を持ちます。" },
          { type: "text", content: "ミュウツー：ミュウの遺伝子操作によって作られた伝説のエスパータイプのポケモン。圧倒的な力を持ちます。" },
          { type: "text", content: "イーブイ：シャワーズ、サンダース、ブースターなど、様々なタイプに進化できる特殊な能力を持つ人気ポケモン。" },
          { type: "text", content: "ギャラドス：弱いコイキングから進化する強力なみず・ひこうタイプのポケモン。" },
          { type: "text", content: "ルカリオ：波導の力を持ち、対戦でも人気の高いかくとう・はがねタイプのポケモン。" },
          { type: "text", content: "ゲッコウガ：アニメシリーズで人気を博したみず・あくタイプの忍者ポケモン。" }
        ]
      },
      "私たちのランダムポケモンジェネレーターを使えば、これらの象徴的なポケモンや、他の魅力的な種類のポケモンを発見することができます。"
    ]
  },
  popularGames: {
    content: [
      "ポケモンゲームシリーズは、様々なプラットフォームで数多くの人気作品を生み出してきました：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "『ポケットモンスター 赤・青・黄』：ゲームボーイで現象を巻き起こした原点となるゲーム。" },
          { type: "text", content: "『ポケットモンスター 金・銀・クリスタル』：ジョウト地方と時間システムを導入。" },
          { type: "text", content: "『ポケットモンスター ルビー・サファイア・エメラルド』：ホウエン地方とダブルバトルで世界を拡大。" },
          { type: "text", content: "『ポケットモンスター ダイヤモンド・パール・プラチナ』：ニンテンドーDSでオンライン機能を実装。" },
          { type: "text", content: "『ポケットモンスター ブラック・ホワイト』：新ポケモンのみの構成とストーリー重視のアプローチ。" },
          { type: "text", content: "『ポケットモンスター X・Y』：3Dモデルとメガシンカを導入。" },
          { type: "text", content: "『ポケットモンスター サン・ムーン』：ジムバトルに代わるしまめぐりを導入。" },
          { type: "text", content: "『Pokémon GO』：世界的な現象となった拡張現実モバイルゲーム。" },
          { type: "text", content: "『ポケットモンスター ソード・シールド』：ワイルドエリアを導入したNintendo Switch作品。" },
          { type: "text", content: "『Pokémon LEGENDS アルセウス』：シリーズ初のオープンワールド形式の作品。" }
        ]
      },
      "各作品は新しいメカニクスとポケモンを導入し、私たちのランダムポケモンジェネレーターで探索できるポケモンの世界を拡大し続けています。"
    ]
  },
  tradingContests: {
    content: [
      "ポケモン交換はシリーズの根幹を成す要素の一つです。最初のゲームがペアで発売されたのも、プレイヤー同士が交換してポケモン図鑑を完成させることを促すためでした。この社会的な要素がポケモンの人気を広め、今日でも重要な役割を果たしています。",
      "交換の主な特徴：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "バージョン限定ポケモンは交換でしか入手できません" },
          { type: "text", content: "カイリキーやユンゲラーなど、交換することで進化するポケモンがいます" },
          { type: "text", content: "現代のゲームではグローバルトレードシステム（GTS）で世界中と交換が可能" },
          { type: "text", content: "レアポケモンや色違いポケモンは、ステータスシンボルとして交換されます" }
        ]
      },
      "第三世代で導入されたポケモンコンテストは、バトル以外の競争方法を提供し、ポケモンの見た目、パフォーマンス、アピールで競い合います。コンテストの特徴：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "様々なコンテスト部門（かっこよさ、うつくしさ、かわいさ、かしこさ、たくましさ）" },
          { type: "text", content: "コンテスト専用の技" },
          { type: "text", content: "きのみやポフィンによるポケモンのコンディション管理" },
          { type: "text", content: "予備審査とパフォーマンスラウンドを含む多段階の競技" }
        ]
      },
      "私たちのランダムポケモンジェネレーターを使えば、コンテストで活躍できるポケモンや、価値の高い交換パートナーとなるポケモンを見つけることができ、ポケモン体験にさらなる広がりをもたらします。"
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "このランダムポケモンジェネレーターは無料で使えますか？",
            answer: "はい、完全無料で、隠れた料金やサブスクリプション料は一切ありません。"
          },
          {
            type: "faq",
            question: "ポケモンのデータはどれくらい正確ですか？",
            answer: "すべてのデータは公式のPokéAPIから取得しており、正確性と最新性が保証されています。"
          },
          {
            type: "faq",
            question: "特定の世代のポケモンだけを生成できますか？",
            answer: "はい、第一世代から第八世代まで選択できます。また、\"すべて\"を選択してすべての世代を含めることもできます。"
          },
          {
            type: "faq",
            question: "レア度フィルターはどのように機能しますか？",
            answer: "伝説/幻のポケモンの状態、基礎経験値などの要因に基づいて、1-10のレア度値を各ポケモンに割り当てています。"
          },
          {
            type: "faq",
            question: "生成したポケモンを保存またはエクスポートできますか？",
            answer: "現在は、スクリーンショットで結果を保存できます。将来のアップデートで保存/エクスポート機能の追加を検討中です。"
          },
          {
            type: "faq",
            question: "ランダムポケモンジェネレーターはモバイル対応していますか？",
            answer: "はい、スマートフォン、タブレット、デスクトップコンピューターで完全に対応しています。"
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "ランダムポケモンジェネレーターは、カジュアルファンと熱心なトレーナーの両方に無限の可能性を提供します。新しいお気に入りを発見したり、テーマチームを作成したり、予期しない組み合わせで自分自身に挑戦したりしたい場合でも、私たちのツールは、広大なポケモンの世界を探検するための楽しく教育的な方法を提供します。",
      "私たちは常に新機能とオプションでジェネレーターを改善するよう努めています。今日、あなたの好みを設定し、「生成」をクリックして、どのポケモンがあなたを待っているかを確認してみてください！",
      "友達や他のトレーナーと結果を共有し、ポケモンの旅でランダムポケモンジェネレーターをどのように使用しているかを教えてください。発見を楽しんでください！"
    ]
  },
  whichPokemonIntro: {
    content: [
      "あなたが最も似ているポケモンは何か疑問に思ったことはありますか？ 私たちの「私はどのポケモン？」ツールは、あなたの身体的特徴に基づいてポケモンの分身を発見するための楽しくユニークな方法を提供します。",
      "この革新的な機能は、あなたの身長と体重を分析して、あなたの体型に最も近いポケモンを特定します。あなたがリザードンのように大きいかピカチュウのようにコンパクトかにかかわらず、私たちのアルゴリズムは驚くべき精度であなたの完璧なポケモンマッチを見つけます。"
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "私たちの「私はどのポケモン？」ツールの使用は簡単で、数秒しかかかりません。以下の簡単な手順に従ってポケモンマッチを発見してください：",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "提供されたフォームにあなたの名前（またはニックネーム）を入力します。" },
          { type: "text", content: "センチメートル（cm）であなたの身長を入力します。" },
          { type: "text", content: "キログラム（kg）であなたの体重を入力します。" },
          { type: "text", content: "「マイポケモンを見つける」ボタンをクリックして結果を確認します。" },
          { type: "text", content: "名前、タイプ、サイズ、重量、類似性スコアを含むマッチングポケモンを確認します。" },
          { type: "text", content: "ソーシャルメディアで結果を共有するか、画像としてダウンロードして友達に見せましょう！" }
        ]
      },
      "類似性スコアは、あなたの体型がポケモンの体型にどれだけ近いかを示しています。パーセンテージが高いほど、マッチングが近いことを意味します！"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "ポケモンの分身を発見することは、単なるエンターテイメント以上の価値を提供します：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "楽しい学習法：あなたの身体的特徴に合った新しいポケモンを発見し、学びます。" },
          { type: "text", content: "ユニークな視点：ポケモンの世界のレンズを通して自分自身を見ることができます。" },
          { type: "text", content: "会話の始まり：友達と結果を共有し、それぞれにどのポケモンが合うかを比較します。" },
          { type: "text", content: "コスプレのインスピレーション：コスプレのアイデアとして、自然にあなたの体型に合うポケモンを見つけます。" },
          { type: "text", content: "チームビルディング：あなたや友達との身体的類似性に基づいて、ポケモンゲームでテーマチームを作成します。" }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "マッチングアルゴリズムはどれくらい正確ですか？",
            answer: "私たちのアルゴリズムはPokéAPIからの公式ポケモンのサイズと重量データを使用し、比例ユークリッド距離に基づいて類似性を計算します。科学的正確さよりも楽しさを目的としていますが、多くのユーザーはマッチングが驚くほど適切だと感じています！"
          },
          {
            type: "faq",
            question: "なぜツールは他の身体的特徴を考慮していないのですか？",
            answer: "現在、シンプルさのために、そしてすべてのポケモン種で最も一貫して記録されている物理的属性であるため、サイズと重量に焦点を当てています。将来のアップデートでは、さらに属性を追加する可能性があります。"
          },
          {
            type: "faq",
            question: "どんなポケモンともマッチングできますか？",
            answer: "現在、パフォーマンスを最適化するために、ツールは元の151匹のポケモン（第1世代）とマッチングしています。将来のアップデートでは、すべての世代を含むように拡張する予定です。"
          },
          {
            type: "faq",
            question: "私の個人データは保存または共有されますか？",
            answer: "いいえ、あなたが入力する身長、体重、またはその他の個人情報は保存しません。すべての計算はブラウザで行われ、サーバーには何も送信されません。"
          },
          {
            type: "faq",
            question: "なぜ似たような測定値を持つ友達と違うポケモンになるのですか？",
            answer: "身長と体重の比率の小さな違いが異なるマッチングにつながる可能性があります。アルゴリズムは絶対値ではなく比率を考慮します。"
          },
          {
            type: "faq",
            question: "ソーシャルメディアで結果を共有できますか？",
            answer: "はい！結果を画像としてダウンロードするか、提供されたボタンを使用してFacebookやTwitterなどのプラットフォームに直接共有できます。"
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "私たちの「私はどのポケモン？」ツールは、素晴らしいポケモンの世界であなたがどのように存在するかについての遊び心のある洞察を提供します。主にエンターテイメントを目的としていますが、多くのユーザーは、単なる身体的類似性を超えて、マッチしたポケモンの性格や能力との驚くべき関連性を発見しています。",
      "入力を少し変更して、異なる身長と体重があなたのマッチングにどのように影響するかを確認したり、友達や家族にポケモンの分身を見つけるよう挑戦したりしてみてください。結果のポケモンペアリングに驚かれるかもしれません！",
      "あなたが壮大な伝説のポケモン、パワフルなスターター、または過小評価されたポケットモンスターとマッチングするかどうかにかかわらず、あなたのポケモンの分身と共有するユニークな特性を受け入れてください。結局のところ、ポケモンの世界では、すべての種がそれぞれ特別な強みと意義を持っています。"
    ]
  }
}; 